import styles from "../../../styles/pages/AllowedIps/components/AddAllowedIpModal.module.css";
import React, { useState, useRef, useEffect, useContext } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { addAllowedIpApi } from "../../../utils/api/AllowedIP/addAllowedIpApi";
import { LangContext } from "../../../context/LangContext";
import { ThemeContext } from "../../../context/ThemeContext";
import { handleError } from "../../../utils/custom/errorHandler";
import { InputSelector } from "../../../components/UI/InputSelector";
import { CircularProgress } from "@mui/material";

const ipField = {
  key: "ip", 
  label: "IP Адрес",
  type: "input"
};

const translations = {
  ru: {
    unknownError: "Произошла неизвестная ошибка",
    title: "Добавить Разрешенный IP",
    confirm: "Подтвердить",
    ip_required: "IP адрес обязателен",
    submitting: "Добавление...",
  },
  en: {
    unknownError: "An unknown error occurred",
    title: "Add Allowed IP",
    confirm: "Confirm",
    ip_required: "IP is required",
    submitting: "Adding...",
  },
};

export const AddAllowedIpModal = ({ handleAddIpModalClose, fetchIps }) => {
  const { langSelected } = useContext(LangContext);
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';
  const t = translations[langSelected] || translations.ru;

  const [formData, setFormData] = useState({ ip: "" });
  const [focused, setFocused] = useState({});
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      handleAddIpModalClose();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleAddIpModalClose]);

  const validate = () => {
    let newErrors = {};
    if (!formData.ip.trim()) {
      newErrors.ip = t.ip_required;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleFocus = (key) => {
    setFocused((prev) => ({ ...prev, [key]: true }));
    setErrors((prev) => ({ ...prev, general: "" })); 
  };

  const handleBlur = (key) => {
    setFocused((prev) => ({ ...prev, [key]: false }));
    setTouched((prev) => ({ ...prev, [key]: true }));
    if (formData[key].trim() && key === 'ip') validate();
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }
    
    setIsSubmitting(true);
    setErrors({});
    const dataToSend = { ip: formData.ip.trim() };

    try {
      await addAllowedIpApi(dataToSend);
      handleAddIpModalClose();
      fetchIps(); 
    } catch (err) {
      handleError(err, setErrors); 
    } finally {
      setIsSubmitting(false);
    }
  };

  const getIpErrorMessage = () => {
    const ipError = errors.ip;
    const generalError = errors.general;

    if (ipError) {
      return Array.isArray(ipError) ? ipError[0] : ipError;
    }
    
    if (generalError) {
        return generalError; 
    }

    return null;
  };

  const hasInputError = !!errors.ip || !!errors.general;


  return (
    <div className={`${styles.modal} ${isDark ? styles.darkModal : ''}`}>
      <div className={`${styles.filtersContainer} ${isDark ? styles.darkFiltersContainer : ''}`} ref={modalRef}>
        <div className={`${styles.modalLabel} ${isDark ? styles.darkModalLabel : ''}`}>
          <p className={`${isDark ? styles.darkModalLabelText : ''}`}>{t.title}</p>
          <div onClick={handleAddIpModalClose} className={`${isDark ? styles.darkModalLabelCloseButton : ''}`}><CloseIcon style={{ cursor: 'pointer' }}/></div>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.section} style={{ gridTemplateColumns: '1fr' }}> 
            
            <div key={ipField.key} className={styles.inputRow}>
              <label className={`${isDark ? styles.darkLabel : ''}`}>{ipField.label}:</label>
              <InputSelector
                filterName={ipField.key}
                selectedValue={formData[ipField.key]}
                handleFilterChange={handleChange}
                onFocus={() => handleFocus(ipField.key)}
                onBlur={() => handleBlur(ipField.key)}
                hasError={hasInputError}
                errorMessage={getIpErrorMessage()}
                isFocused={focused[ipField.key]}
                isDark={isDark}
              />
            </div>
          </div>
        </div>

        <div className={`${styles.modalFooter} ${isDark ? styles.darkModalFooter : ''}`}>
          <div className={styles.confirmationWrapper}>
            <button
              className={`${styles.submitButton} ${isDark ? styles.darkSubmitButton : ''}`}
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? <CircularProgress size={20} color="inherit" /> : t.confirm}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};